// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper-2zVj3","search":"search-2QRYf","searchIcon":"searchIcon-15KiV"};